/**
 * One money picture per sealed month, shared by Home, Insights and the close pack so they
 * can never disagree: the month's statement transactions plus Migrate World costs logged as
 * paid outside the tracked accounts (cash, Wise, someone paying for you).
 */
import { mwOutsideFor } from '../lib/mw';
import type { Month } from '../data/types';
import { monthMoney } from '../lib/decisions';
import { monthKey } from '../lib/periods';
import { useApp } from './context';
import { useAsync } from './hooks';

export function useSealedMoney(month: Month | null) {
  const { repo } = useApp();
  return useAsync(async () => {
    if (!month) return null;
    const [txs, mw] = await Promise.all([repo.transactions(month.month_start), repo.mw().catch(() => null)]);
    const key = monthKey(month.month_start);
    const outside = mwOutsideFor(mw?.costs ?? [], key);
    return { txs, money: monthMoney(txs, outside) };
  }, [month?.id]);
}
